import React from 'react';
import { useTranslation } from 'react-i18next';
import { EnumInvoiceStatus } from 'api';
import InfoRow from 'components/InfoRow/InfoRow';
import { NOT_AVAILABLE } from 'constants/text';
import dateTimeFormatter from 'utils/date/dateTimeFormatter';
import getInvoiceTranslationString from 'utils/invoices/getInvoiceTranslationString';
export default function InvoiceDetailsRow(invoice) {
  const {
    t
  } = useTranslation();
  const dueDate = dateTimeFormatter(invoice.dueDate);
  const invoiceDate = dateTimeFormatter(invoice.invoiceDate);
  const invoiceStatusString = getInvoiceTranslationString(invoice.invoiceStatus);
  const isCreditNote = invoice.invoiceStatus === EnumInvoiceStatus.CreditNote;
  const isRemittance = invoice.invoiceStatus === EnumInvoiceStatus.Remittance;
  const isPaidByBalance = invoice.invoiceStatus === EnumInvoiceStatus.PaidByBalance;
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(InfoRow, {
    primary: t('invoices.invoice_date'),
    secondary: invoiceDate
  }), !isCreditNote && !isRemittance && !isPaidByBalance && /*#__PURE__*/React.createElement(InfoRow, {
    primary: t('invoices.due_date'),
    secondary: dueDate
  }), /*#__PURE__*/React.createElement(InfoRow, {
    primary: t('invoices.amount'),
    secondary: `${invoice.totalPriceVatIncluded} ${invoice.currency}`
  }), /*#__PURE__*/React.createElement(InfoRow, {
    primary: t('invoices.amount_paid'),
    secondary: `${invoice.actualAmountPaid} ${invoice.currency}`
  }), /*#__PURE__*/React.createElement(InfoRow, {
    primary: t('invoices.invoice_status'),
    secondary: t(`invoice_status.${invoiceStatusString}`)
  }), !isCreditNote && !isRemittance && /*#__PURE__*/React.createElement(InfoRow, {
    primary: t('invoices.kid'),
    secondary: invoice.customerIdentificationNumber || NOT_AVAILABLE
  }), isCreditNote && /*#__PURE__*/React.createElement(InfoRow, {
    primary: t('invoices.legacy_invoice_number'),
    secondary: invoice.legacyInvoiceNumber || NOT_AVAILABLE
  }), /*#__PURE__*/React.createElement(InfoRow, {
    primary: t('agreements.agreement_name'),
    secondary: invoice.agreementName || NOT_AVAILABLE
  }), /*#__PURE__*/React.createElement(InfoRow, {
    primary: t('invoices.distribution_channel'),
    secondary: invoice.distributionChannel || NOT_AVAILABLE
  }), !isCreditNote && !isRemittance && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(InfoRow, {
    primary: t('invoices.company_bank_account_number'),
    secondary: invoice.companyBankAccountNumber
  }), /*#__PURE__*/React.createElement(InfoRow, {
    primary: t('invoices.company_IBAN'),
    secondary: invoice.companyIBAN
  }), /*#__PURE__*/React.createElement(InfoRow, {
    primary: t('invoices.company_SWIFT'),
    secondary: invoice.companySWIFT
  })));
}